import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetHoldingClassesProps = {
  holdingClassId: string;
  signal?: AbortSignal;
};

export const getHoldingClassById =
  ({ holdingClassId, signal }: GetHoldingClassesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get(`/holdingClasses/${holdingClassId}`);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
